var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader-serverless-form_box"},[_c('input',{attrs:{"type":"file","id":"imageFile_name"},on:{"change":_vm.onImageChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }